import * as React from 'react';
import * as Tgcc from '../../tgccGlobal';
import { CSSProperties } from 'react';

const wrapperStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'CenturyGothic',
    height: 'auto',
    minWidth: '300px',
    maxHeight: '80%',
    background: 'white',
    alignSelf: 'center',
    flex:'50%',
    marginBottom:'5%'
}

const contentStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
    backgroundColor: 'white',
    alignItems: 'center',
    justifyContent: 'center'
}
const imgStyle: React.CSSProperties = {
    display: 'flex',
    alignSelf: 'center',
    maxWidth: '325px',
    margin: '25px auto',
    cursor: 'pointer',
    maxHeight:'407px'
}
const priceStyle: React.CSSProperties = {
    display: 'flex',
    alignSelf: 'flex-end',
    lineHeight: '35px',
    maxWidth: '500px',
    fontSize: '22px',
}
const addStyle: React.CSSProperties = {
    display: 'flex',
    alignSelf: 'stretch',
    justifyContent: 'center',
    fontSize: '20px',
    lineHeight: '30px',
    maxWidth: '500px',
    cursor: 'pointer',
    border:'2px solid black'
}
type Props = {
    proofId: string;
    price: number;
    addCallback: (proofId: string) => void;
    showCloseUp: (proofId: string) => void;
}

export class ShopCard extends React.Component<Props, any>{

    onError = (evt: React.SyntheticEvent<HTMLImageElement>) => {
        evt.currentTarget.src = Tgcc.Styles.missingProofImageSrc;
    }
    onClick = (evt: any) => {
        if (this.props.addCallback)
            this.props.addCallback(this.props.proofId);
    }
    showCloseUp = (evt: any) => {
        this.props.showCloseUp(this.props.proofId);
    }
    render() {
        var imgPath = Tgcc.getProofPath(this.props.proofId);

        return (
            <div style={wrapperStyle} className="shopItemWrapper">
                <div style={contentStyle}>
                    <img style={imgStyle} src={imgPath} className="shopItemImg" onError={this.onError} onClick={this.showCloseUp} />
                    <div style={priceStyle}>${this.props.price}</div>
                    <button style={addStyle} onClick={this.onClick}>Add to Cart</button>
                </div>
            </div>
        )
    }
}

